import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { SUPPORTED_LANGS } from "@/i18n";

/**
 * 2-state cycle: EN ↔ TR.
 * Persists via i18next-browser-languagedetector (localStorage key
 * `growtify-cockpit-lng`).
 */
export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "en").slice(0, 2);
  const next = current === "tr" ? "en" : "tr";

  const cycle = () => {
    const idx = SUPPORTED_LANGS.indexOf(current as (typeof SUPPORTED_LANGS)[number]);
    const target = SUPPORTED_LANGS[(idx + 1) % SUPPORTED_LANGS.length] || "en";
    i18n.changeLanguage(target);
  };

  return (
    <button
      type="button"
      onClick={cycle}
      title={t("language.title")}
      aria-label={t("language.title")}
      className="inline-flex items-center justify-center gap-1 h-7 sm:h-8 px-1.5 rounded-md border border-slate-700 bg-slate-900 text-slate-400 hover:text-slate-200 hover:border-slate-600"
    >
      <Languages className="h-3.5 w-3.5" />
      <span className="text-[11px] uppercase tabular-nums">{current}</span>
      <span className="hidden sm:inline text-[10px] text-slate-600">→ {next}</span>
    </button>
  );
}
